import React, { useState, useRef } from "react";
import { Alert, Box, Link } from "@mui/material";
import SelectDropdown from "../SelectDropdown/SelectDropdown";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import { URL_CONSTANTS } from "../../APIVar/URLConstants";
interface Props {
  title: string;
  value: string;
  attrName: any;
  value_update: Function;
  dropdown_data: Array<any>;
  warn_status?: boolean;
  class_name?: string;
  error_messg?: string;
  info_status?: boolean;
  // required?: boolean;
  info_message?: string;
  params?: any;
  id?: string;
}

const SelectDropdownDisable: React.FC<Props> = ({
  title,
  value,
  value_update,
  attrName,
  dropdown_data,
  warn_status,
  class_name,
  error_messg,
  info_status,
  // required,
  params,
  id,
  info_message,
}) => {
  const [disbaleToggle, setDisableToggle] = useState<boolean>(false);

  const updateMasterState = (attrName: any, value: any) => {
    value_update(attrName, value);
  };
  const [focus, setFocus] = useState<boolean>(false);
  const refinput = useRef(null);
  // individual edit
  const edit = () => {
    setDisableToggle(!disbaleToggle);
    setFocus(true);
    if (disbaleToggle === false) {
      // const input = document.getElementById(value);
      // console.log(input);
      // input?.focus();
    }
    // if (disbaleToggle === true) {
    //   individual_edit();
    // }
  };
  // const individual_edit = () => {
  //   Patch(`${URL_CONSTANTS.edit_contact}${id}`, params).then((data: any) => {
  //     let status = data[0];
  //     let response = data[1];
  //     console.log(data);
  //     if (status === "success") {
  //       alert("Data update successfully");
  //     }
  //     if (status.response.data.status === "failed") {
  //       console.log("eeeee---", status.response.data.errors[0].message);
  //       let param = status.response.data.errors[0].param;
  //       let error = status.response.data.errors[0].message;
  //       alert(param + " " + " " + error);
  //     }
  //   });
  // };
  return (
    <Box className="individualEdit">
      {disbaleToggle === false ? (
        <div className="staticField">
          <label>{title}</label>
          <p>{value}</p>
        </div>
      ) : (
        <SelectDropdown
          class_name={class_name}
          title={title}
          value_update={updateMasterState}
          value={value}
          attrName={attrName}
          dropdown_data={dropdown_data}
          warn_status={warn_status}
          // required={required}
          error_messg={error_messg}
          info_status={info_status}
          info_message={info_message}
        />
      )}
      <Link
        className={disbaleToggle === true ? "editUpdate visible" : "editUpdate"}
        onClick={edit}
      >
        {disbaleToggle === false ? <EditIcon /> : <CheckIcon />}
      </Link>
    </Box>
  );
};

export default SelectDropdownDisable;
